import { trackPromise } from "react-promise-tracker";
import { axiosBridge } from "../network/AxiosBridge";
import { API_URL, StatusCodes } from "../network/Configurations";

const getUserKyc = (params): Promise => {
  return new Promise((resolve, reject) => {
    trackPromise(
      axiosBridge
        .get(API_URL.GET_USERS_KYC, { params })
        .then((response) => {
          if (
            response.data.code === StatusCodes.SUCCESS ||
            response.data.code === StatusCodes.NO_DATA_FOUND
          ) {
            resolve(response.data);
          } else reject(response.data);
        })
        .catch((error) => {
          reject(error);
        })
    );
  });
};

const getImagesList = (params): Promise => {
  return new Promise((resolve, reject) => {
    trackPromise(
      axiosBridge
        .get(`${API_URL.GET_USERS_MEDIA}?mediaType=Image`, { params })
        .then((response) => {
          if (
            response.data.code === StatusCodes.SUCCESS ||
            response.data.code === StatusCodes.NO_DATA_FOUND
          ) {
            resolve(response.data);
          } else reject(response.data);
        })
        .catch((error) => {
          reject(error);
        })
    );
  });
};

const kycConfirmation = (params: any): Promise => {
  return new Promise((resolve, reject) => {
    trackPromise(
      axiosBridge
        .put(API_URL.MARK_KYC_COMPLETE, {}, { params })
        .then((response) => {
          if (response.data.code === StatusCodes.SUCCESS) {
            resolve(response.data);
          } else reject(response.data);
        })
        .catch((error) => {
          reject(error);
        })
    );
  });
};

const kycConfirmationMark = (params: any): Promise => {
  return new Promise((resolve, reject) => {
    trackPromise(
      axiosBridge
        .post(API_URL.ADMIN_ADD_KYC, {}, { params })
        .then((response) => {
          if (response.data.code === StatusCodes.SUCCESS) {
            resolve(response.data);
          } else reject(response.data);
        })
        .catch((error) => {
          reject(error);
        })
    );
  });
};

export const KycService = {
  getUserKyc,
  getImagesList,
  kycConfirmation,
  kycConfirmationMark,
};
